import { LitElement, html, css } from '@hh/global.js'

class HHQuantitySelect extends LitElement {
  static properties = {
    key: {},
    initial: {
      type: Number,
    },
    _value: {
      state: true,
    },
  }

  constructor() {
    super()

    this.broadcast = this.broadcast.bind(this)
    this.id = Math.random() * 100000
  }

  connectedCallback() {
    super.connectedCallback()
    this._value = this.initial
  }

  broadcast() {
    this.dispatchEvent(
      new CustomEvent('changeQuantity', {
        bubbles: true,
        composed: true,
        detail: {
          key: this.key,
          value: this._value,
        },
      })
    )
  }

  override(e) {
    this._value = e.target.value
    this.broadcast()
  }

  render() {
    return html`
      <span>
        <select
          id="Quantity-${this.id}"
          class="quantity-select"
          name="updates[]"
          @change="${this.override}"
        >
          ${Array.from(
            { length: 10 },
            (_, i) => html`<option value="${i + 1}">${i + 1}</option>`
          )}
        </select>
      </span>
    `
  }

  static styles = css`
    .quantity-select {
      -webkit-appearance: none;
      background-color: transparent;
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0h24v24H0z'/%3E%3Cpath stroke='%23313131' stroke-width='.66' stroke-linecap='round' stroke-linejoin='round' d='m16 9-4-4-4 4m8 6-4 4-4-4'/%3E%3C/g%3E%3C/svg%3E");
      background-position-x: 100%;
      background-position-y: center;
      background-repeat: no-repeat;
      background-size: 24px;
      border: 1px solid rgba(65, 65, 65, 0.2);
      border-radius: 12px;
      box-sizing: border-box;
      color: currentColor;
      cursor: pointer;
      height: 48px;
      min-width: 86px;
      padding: 0 14px;
    }
  `
}

customElements.define('hh-quantity-select', HHQuantitySelect)
